import { CommonModule } from "@angular/common";
import { Component, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslocoDirective } from "@jsverse/transloco";
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from "@ngx-formly/core";

export function isWysiwygDisplayField(field: FormlyFieldConfig): field is FormlyFieldConfig & {
  type: "wysiwygDisplay";
} {
  return field.type === "wysiwygDisplay";
}

@Component({
  selector: "app-formly-wysiwyg-display",
  templateUrl: "./wysiwyg-display.type.html",
  styleUrl: "./wysiwyg-display.type.scss",
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
})
export class WysiwygDisplayComponent extends FieldType<FieldTypeConfig> {
  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  get displayValue(): string {
    const value = this.formControl.value;
    if (value === null || value === undefined) {
      return "";
    }

    return String(value);
  }

  get sanitizedHtml(): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, this.displayValue) || "";
  }
}
